module.exports = __webpack_public_path__ + "static/media/VRsim.5e4d9fb1.jpg";